<app-add-edit-reminder-def *ngIf="reminderDef && reminderDefLoaded" [reminderDef]="reminderDef">
</app-add-edit-reminder-def>

<mat-spinner *ngIf="!reminderDefLoaded && !reminderDefLoadFailed" [diameter]="70">

</mat-spinner>

<p *ngIf="reminderDefNotFound">{{'REMINDER_NOT_FOUND' | translate}}</p>

<div *ngIf="reminderDefLoadFailed">
  <p>Unable to load reminder.</p>
  <button mat-button color="primary" (click)="retryLoadReminderDef()">Retry</button>
</div>
